export default __webpack_public_path__ + "static/media/4569.b32de5af.png";